
const DEFAULT_ENTITY_LABELS = {
  brand: "Brand",
  product: "Product",
  rank:"Visibility",
  brandPlaceHolder: "Nike",
  productPlaceHolder: "Nike Air Force 1",
  personaPlaceHolder:"eg Marketing Manager",
  categoryTypePlaceHolder:"eg Companies",
  categoryPlaceHolder:"eg Athletic Apparel",
  purchaseCriteria: "Purchase Criteria",
  brandPillar:"Brand Pillars",
  productDimension:"Product Dimension",
  brandIndexScore: "Brand Index Score",
  productIndexScore:" Product Index Score",
  brandSnippets:"Brand Snippets",
  productSnippets:"Product Snippets",
  brandThemes:"Brand Themes",
  productThemes:"Product Themes",
  brandAttributes:"Brand Attributes",
  productAttributes:"Product Attributes",
  buyingJourney:"Buying Journey",
  postPurchase:"Post-Purchase",
  customer:"Customer",
  purchase:"Purchase"
};


let _cachedLabels = null;
let _cachedRaw = undefined; 
function resolveEntityLabels() {
  try {
    const raw = localStorage.getItem("customer_ui_info");

    // Cache hit — localStorage hasn't changed, return cached object instantly
    // Cost: one string comparison ~0.001ms instead of JSON.parse ~0.1ms
    if (raw === _cachedRaw && _cachedLabels !== null) {
      return _cachedLabels;
    }

    // Cache miss — localStorage changed (login/logout), rebuild object once
    _cachedRaw = raw;
    const customerUiInfo = raw ? JSON.parse(raw) : null;
    _cachedLabels = customerUiInfo
      ? { ...DEFAULT_ENTITY_LABELS, ...customerUiInfo }
      : DEFAULT_ENTITY_LABELS;

    return _cachedLabels;
  } catch {
    return DEFAULT_ENTITY_LABELS;
  }
}

export function invalidateLabelCache() {
  _cachedLabels = null;
  _cachedRaw = undefined;
}

export const ENTITY_LABELS = new Proxy(
  {},
  {
    get(_, key) {
      return resolveEntityLabels()[key];
    },
  }
);

export function mapLabel(label) {
  if (!label) return label;
  return label
    .replace(/\bCompany\/Brand\b/g, ENTITY_LABELS.brand)
    .replace(/\bBrand\b/g, ENTITY_LABELS.brand)
    .replace(/\bProduct\b/g, ENTITY_LABELS.product);
}

export function getEntityLabel(type) {
  if (type === "brand") return ENTITY_LABELS.brand;
  if (type === "product") return ENTITY_LABELS.product;
  return type;
}